// globals: jQuery
import {TerminalTransactionWebSocket} from "@cashflow/cashflow-websockets";
/**
 * CashFlowEMVTerminal
 *
 * @author Himanshu Rajput
 *
 * @param params
 * @constructor
 * @returns {CashFlowEMVTerminal}
 */
function CashFlowEMVTerminal(params) {
    this.params = params ? params : {};
}

const cancelTransaction = 'Cancel';
const cancelTransactionStatus = 6;
let cancelStatusCheck = 0;
/**
 * @description Connect EMV Terminal Request for CashFLow
 * @param params
 * @param callback
 */
CashFlowEMVTerminal.prototype.callTerminal = function (params, callback) {
    window.TerminalTransactionWebSocket = TerminalTransactionWebSocket;
    const handleOnError = function (data) {
        jQuery('body').caLoadingSplash('hide');
    };
    const handleOnTransactionEvent = function (data) {
        if (data.message === cancelTransaction && data.status === cancelTransactionStatus) {
            jQuery.caAlert(
                'Transaction has been cancelled.',
                '' +
                '',
                {className: 'cf-close-alertbox'}
            );
            jQuery('body').caLoadingSplash('hide');
        }
        callback(data);
    };

    const handleOnTransactionInitiated = function (data) {
        callback(data);
    };

    const handleOnTransactionSuccess = function (data) {
        jQuery('body').caLoadingSplash('hide');
        callback(data);
        self.callTerminalInProgress = false;
    };

    const handleOnTransactionError = function (data) {
        jQuery('body').caLoadingSplash('hide');
        if (data.hasOwnProperty('errorMessage')) {
            jQuery.caAlert(data.errorMessage);
        }
        callback(data);
    };


    const processTransaction = async () => {
        try {
            const amountElement = document.querySelector('#amount');
            const emvAccountIdElement = document.querySelector('#emvAccountId');
            const emvPublicKeyElement = document.querySelector('#emvPublicKey');
            const emvTerminalIdElement = document.querySelector('#emvTerminalId');

            const totalAmount = Number(amountElement?.value);
            const gatewayEmvAccountId = parseInt(emvAccountIdElement?.value ?? '');
            let gatewayEmvPublicKey = emvPublicKeyElement?.value ?? '';
            gatewayEmvPublicKey = gatewayEmvPublicKey.trim();
            const emvTerminalId = parseInt(emvTerminalIdElement?.value ?? '');
            jQuery('body').caLoadingSplash('show');
            this.callTerminalInProgress = true;
            const conn = new TerminalTransactionWebSocket({
                baseUri: 'https://ws.dev-services.gainspro.com/api',
                onTransactionError: handleOnTransactionError,
                onTransactionEvent: handleOnTransactionEvent,
                onTransactionSuccess: handleOnTransactionSuccess
            });

            await conn.authTransaction({
                accountId: gatewayEmvAccountId,
                publicKey: gatewayEmvPublicKey,
                amount: totalAmount,
                terminalId: emvTerminalId,
                promptForTip: false,
                requestSignature: true,
                printReceipt: false,
                printExtraReceipt: false,
                isCapture: false
            });
        } catch (e) {
            handleOnError(e.message);
        }
    }
    processTransaction();
};

CashFlowEMVTerminal.prototype.callTokenizationTerminal = function (params, callback) {
    const $dialogContent = jQuery('<div>'
        + '<p class="pos-terminal-text">Please process payment through the EMV terminal.</p>'
        + '</div>');
        
    const handleOnTokenizeEvent = function (data) {
        jQuery('body').caLoadingSplash('hide');
        if(!cancelStatusCheck) {
            $dialogContent.caDialog({
                title: 'Transaction In Progress...',
                resizable: false,
                width: 600,
                showCloseButton: false,
                modal: true,
            });
        }
        if (data.message === cancelTransaction && data.status === cancelTransactionStatus) {
            jQuery.caAlert('Transaction has been cancelled.');
            $dialogContent.caDialog('close');
            cancelStatusCheck = 1;
        }
    };
    const handleOnTokenizeError = function (data) {
        jQuery('body').caLoadingSplash('hide');
        $dialogContent.caDialog('close');
        if (data.hasOwnProperty('errorMessage')) {
            jQuery.caAlert(data.errorMessage);
        }
        callback(data);
    };
    const handleOnTokenizeSuccess = function (data) {
        $dialogContent.caDialog('close');
        callback(data);
    };
    const processTransaction = async() => {
        const gatewayEmvAccountId = parseInt(document.querySelector('#emvAccountId')?.value);
        const gatewayEmvPublicKey = (document.querySelector('#emvPublicKey')?.value).toString();
        const emvTerminalId = parseInt(document.querySelector('#emvTerminalId')?.value);
        jQuery('body').caLoadingSplash('show');

        try {
            const conn = new TerminalTransactionWebSocket({
                baseUri: 'https://ws.dev-services.gainspro.com/api',
                onTokenizeEvent: handleOnTokenizeEvent,
                onTokenizeError: handleOnTokenizeError,
                onTokenizeSuccess: handleOnTokenizeSuccess
            });

            await conn.initiateTokenize({
                accountId: gatewayEmvAccountId,
                publicKey: gatewayEmvPublicKey,
                terminalId: emvTerminalId,
            });
        } catch (error) {
            jQuery('body').caLoadingSplash('hide');
        }
    };
    processTransaction();
};

export default CashFlowEMVTerminal;
